import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/community';
import Hero from './components/Hero';
import HotTopics from './components/HotTopics';
import Boards from './components/Boards';
import LatestPosts from './components/LatestPosts';
import TopicsSection from './components/TopicsSection';
import Features from './components/Features';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  return (
    <Layout>
      <Hero />
      <HotTopics />
      <Boards />
      <LatestPosts />
      <TopicsSection />
      <Features />

      <section className="bg-background-100/60">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="text-xs font-semibold tracking-widest text-primary-600">FAQ</span>
              <h2 className="mt-1 font-heading text-2xl md:text-3xl">加入前，你可能想问</h2>
              <p className="mt-3 text-sm text-foreground-600">
                关于羞羞动漫社的常见问题都在这里，如果还有疑问，欢迎随时联系我们。
              </p>
              <Link
                to="/faq"
                className="mt-5 inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800"
              >
                查看全部常见问题 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <FaqAccordion items={faqs.slice(0, 3)} />
          </div>
        </div>
      </section>

      <CtaBanner />
    </Layout>
  );
}